<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="19.998"
        height="20.087"
        viewBox="0 0 19.998 20.087"
        fill="currentColor">
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_307"
                    data-name="Rectangle 307"
                    width="19.998"
                    height="20.087"
                    transform="translate(0 0)" />
            </clipPath>
        </defs>
        <g id="Group_1427" data-name="Group 1427" transform="translate(0 0)" clip-path="url(#clip-path)">
            <path
                id="Path_329"
                data-name="Path 329"
                d="M17.082,2.915l0,0A9.959,9.959,0,0,0,1.413,14.928L0,20.087,5.279,18.7a9.959,9.959,0,0,0,11.8-15.788m-2.167,10.6a2.563,2.563,0,0,1-1.679,1.183,3.407,3.407,0,0,1-1.567-.1,14.506,14.506,0,0,1-1.418-.524A11.085,11.085,0,0,1,6,10.314,4.84,4.84,0,0,1,4.981,7.74a2.79,2.79,0,0,1,.871-2.075.911.911,0,0,1,.664-.311c.166,0,.324,0,.477.009s.353-.071.56.427.705,1.723.767,1.847a.457.457,0,0,1,.021.435,1.733,1.733,0,0,1-.249.415c-.124.145-.249.312-.373.436s-.254.259-.109.508A7.5,7.5,0,0,0,9,11.151a6.788,6.788,0,0,0,2,1.235c.249.125.394.1.539-.062s.622-.725.788-.975.332-.208.56-.125,1.451.684,1.7.809v0c.249.125.415.191.477.291a2.079,2.079,0,0,1-.145,1.183"
                fill-rule="evenodd" />
        </g>
    </svg>
</template>
<script setup lang="ts"></script>
